import type { BatchesAction, BatchesState } from "./batches-context.types";

export const createInitialBatchesState = (): BatchesState => ({
  batches: [],
  isInitialized: false,
  isLoading: false,
  isSuccess: false,
  isProcessing: false,
  loadingKeys: {},
});

export const reducer = (state: BatchesState, action: BatchesAction): BatchesState => {
  switch (action.type) {
    case "SET_INITIALIZED":
      return {
        ...state,
        isInitialized: action.payload,
      };
    case "SET_LOADING":
      return {
        ...state,
        isLoading: action.payload,
      };
    case "SET_SUCCESS":
      return {
        ...state,
        isSuccess: action.payload,
      };
    case "SET_PROCESSING":
      return {
        ...state,
        isProcessing: action.payload,
      };
    case "SET_ERROR":
      return {
        ...state,
        error: action.payload,
      };
    case "SET_BATCHES":
      return {
        ...state,
        batches: action.payload,
      };
    case "SET_BATCH":
      return {
        ...state,
        batch: action.payload,
      };
    case "SET_BATCH_ID":
      return {
        ...state,
        batchId: action.payload,
      };
    case "SET_PARAMS":
      return {
        ...state,
        params: action.payload,
      };
    case "SET_LOADING_KEY":
      return {
        ...state,
        loadingKeys: {
          ...state.loadingKeys,
          [action.payload.key]: action.payload.value,
        },
      };
    default:
      return state;
  }
};

export const setLoadingKey = (key: string, value: boolean): BatchesAction => ({
  type: "SET_LOADING_KEY",
  payload: { key, value },
});
